module.exports = __webpack_public_path__ + "img/coolicon.4c58b96b.svg";